import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { InternalGrid, Title } from '@paygreen/paygreen-ui';
import { ErrorBoundary, CollapsibleCard } from '../../../components';
import { convertCarbonReports, IsDesktop } from '../../../utils/tools';
import DashboardCardSkeleton from './DashboardCardSkeleton';
import DashboardCardTotalCo2 from './DashboardCardTotalCo2';
import DashboardCardOrigins from './DashboardCardOrigins';

const DashboardCardCO2Emitted = ({ t, isLoading, reportsData }) => (
    <CollapsibleCard
        title={t('dashboard.co2OriginsCard.title')}
        blockWidth="none"
        paddingLateral="sm"
        paddingTop="sm"
        paddingBottom="sm"
    >
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="100%"
            alignItems="stretch"
            justifyItems="stretch"
            childrenMarginTop="xs"
        >
            <div>
                <Title htmlTag="h3" colorWab="grey50" marginBottom="xs">
                    {t('dashboard.co2OriginsCard.subtitleTotal')}
                </Title>

                <ErrorBoundary>
                    {isLoading ? (
                        <DashboardCardSkeleton blockWidth="none" />
                    ) : (
                        <DashboardCardTotalCo2
                            carbonData={convertCarbonReports(
                                reportsData,
                                'emitted',
                            )}
                        />
                    )}
                </ErrorBoundary>
            </div>

            <div>
                <Title
                    htmlTag="h3"
                    colorWab="grey50"
                    marginBottom="xs"
                    marginTop={IsDesktop() ? 'xs' : 'sm'}
                >
                    {t('dashboard.co2OriginsCard.subtitleOrigin')}
                </Title>

                <DashboardCardOrigins
                    reportsData={reportsData?.emissionDistribution}
                    isLoading={isLoading}
                />
            </div>
        </InternalGrid>
    </CollapsibleCard>
);

DashboardCardCO2Emitted.propTypes = {
    reportsData: PropTypes.object,
    isLoading: PropTypes.bool,
};

DashboardCardCO2Emitted.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(DashboardCardCO2Emitted);
